import Main from './main';

const setupPoliciesFaq = () => {
	const faqRoot = document.querySelector('[data-policy-faq]');

	if (!faqRoot) {
		return;
	}

	const faqItems = Array.from(faqRoot.querySelectorAll('[data-faq-item]'));

	const closeItem = item => {
		item.classList.remove('is-open');

		const toggle = item.querySelector('[data-faq-toggle]');

		if (toggle) {
			toggle.setAttribute('aria-expanded', 'false');
		}
	};

	const openItem = item => {
		item.classList.add('is-open');

		const toggle = item.querySelector('[data-faq-toggle]');

		if (toggle) {
			toggle.setAttribute('aria-expanded', 'true');
		}
	};

	faqItems.forEach(item => {
		const toggle = item.querySelector('[data-faq-toggle]');

		if (!toggle) {
			return;
		}

		toggle.addEventListener('click', () => {
			const alreadyOpen = item.classList.contains('is-open');

			faqItems.forEach(faqItem => closeItem(faqItem));

			if (!alreadyOpen) {
				openItem(item);
			}
		});
	});

	faqItems.forEach((item, index) => {
		if (index === 0) {
			openItem(item);
		} else {
			closeItem(item);
		}
	});
};

Main.init();
setupPoliciesFaq();
